import React, {useEffect, useState} from 'react';
import Query from '../../components/Query';
import {useMutation, useQuery} from '@apollo/client';
import {MUTATION_CONTEST_CLIENT_SAVE, QUERT_CONTEST_ITEM_LIST} from './graphql';
import moment from 'moment';

const ContestClient = ({obj, contest}) => {
  const [activeIdx, setActiveIdx] = useState(0);
  const [duration, setDuration] = useState(0);
  
  const activeAnswer = obj.answers[activeIdx];
  const activeRightAnswer = obj.rightAnswers[activeIdx];
  const isRight = activeAnswer === activeRightAnswer;

  useEffect(() => {
      setTimeout(() => {
        setDuration(parseInt(moment().diff(moment(obj.startedAt))/1000));
      }, [1000]);
  }, [duration]);

  const query = useQuery(QUERT_CONTEST_ITEM_LIST, {variables: {contestId: obj.contestId}});
  const list = query.data ? query.data.contestItemList : [];

  const active = list[activeIdx];

  const [choose] = useMutation(MUTATION_CONTEST_CLIENT_SAVE);

  const isFinished = obj.isFinished || duration > contest.duration || moment(contest.endTime).isBefore(moment());

  return Query(query) || (
    <div>
      <div className="text-center mb-4">
        {isFinished ? (
          <div>
            <div className="font-5 text-info">Тест завершен</div>
            <div className="font-4">Ваш балл: <span className="text-info">{obj.answersCount}</span></div>
            <div className="font-4">Ваше время: <span className="text-info">{moment.utc(obj.duration * 1000).format('mm:ss')}</span></div>
          </div>
        ) : (
          <div>
            <div className="font-4">
              <span>Ответы: </span>
              <span className="text-info">{obj.answersCount} </span>
              <span> из {list.length}</span>
            </div>
            <div className="row g-1 justify-content-center">
              <div className="col-auto">Время: </div>
              <div className="col-auto text-info">{moment.utc(duration * 1000).format('mm:ss')}</div>
              <div className="col-auto">из {moment.utc(contest.duration * 1000).format('mm:ss')}</div>
            </div>
            <div className="font-2 text-muted">Тест будет доступен до {moment(contest.endTime).format('HH:mm:ss')}</div>
          </div>
        )}
      </div>
      <div className="row g-3 justify-content-center">
        {list.map((item, idx) => {
          const activeAnswer = obj.answers[idx];
          const activeRightAnswer = obj.rightAnswers[idx];
          const isRight = activeAnswer === activeRightAnswer;

          return (
            <div key={item.id} className="col-auto">
              <button
                onClick={() => setActiveIdx(idx)}
                className={`btn ${activeIdx === idx ? (activeAnswer ? (isRight ? 'btn-success' : 'btn-danger') : 'btn-secondary') : 'btn-light bg-white'} border border-2 ${activeAnswer ? (isRight ? 'border-success' : 'border-danger') : 'border-secondary'}`}
              >
                {idx + 1}
              </button>
            </div>
          );
        })}
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 my-4 px-3">
            <div className="border border-secondary p-4 text-center rounded">{active.question}</div>
            <div className="mt-3 row g-2">
              {active.variants.map((variant, idx) => (
                <div className="col-6 align-items-center">
                  <button 
                    disabled={!!activeAnswer} 
                    onClick={() => choose({variables: {input: {id: obj.id, contest: obj.contestId, answers: obj.answers.map((x, idx) => activeIdx === idx ? variant : x)}}})}
                    className={`btn w-100 rounded-pill border border-secondary ${activeAnswer === variant ? (isRight ? 'btn-success' : 'btn-danger') :  activeRightAnswer === variant ? 'btn-success' : 'btn-light'}`}
                  >
                    {variant}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContestClient;
